// styles
import "../themes/common.scss";
import "../themes/css/pages/general-insurance.scss";
//js
import "../themes/js/common.js";
import "../themes/js/pages/general-insurance.js";

import { initmanage } from "../javascripts/component/manage.js";

initmanage();

